module.exports = __webpack_public_path__ + "52ce0aa103026e43ccd255fe6a7131bc.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/labels/mouth.svg
// module id = 6TzD
// module chunks = 0